<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: 'bankAccount/List' }">银行账户</el-breadcrumb-item>
                <el-breadcrumb-item>银行账户{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="item['prop'] == 'rel_type' && data[item['prop']] != ''"
                                    ></vDropdown>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                        :disabled="item['prop'] == 'rel_rid' && data[item['prop']] != ''"
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit } from '@/js/common.js';

export default {
    name: 'bankAccountEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.rel_rid = this.$route.query.rel_rid || '';
            this.data.rel_type = this.$route.query.rel_type || '';
            this.initFormData();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                rel_type: {
                    request_uri: 'dropdownBankRelType',
                    title: '关联类型',
                    ref: 'rel_type_ref',
                    select_value: 'value',
                    type: 'dropdown'
                }
            };
        },
        initFormRule() {
            this.rules = {
                rel_type: [{ required: true, message: '请选择关联类型', trigger: 'blur' }],
                rel_rid: [{ required: true, message: '请选择关联对象', trigger: 'blur' }],
                account_name: [{ required: true, message: '请输入户名', trigger: 'blur' }],
                account_code: [{ required: true, message: '请输入银行账号', trigger: 'blur' }],
                opening_bank: [{ required: true, message: '请输入开户行', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                rel_type: this.data.rel_type || '',
                rel_rid: this.data.rel_rid || '',
                account_name: this.data.account_name || '',
                account_code: this.data.account_code || '',
                opening_bank: this.data.opening_bank || '',
                bank_code: this.data.bank_code || '',
                bank_name: this.data.bank_name || '',
                bank_branch_no: this.data.bank_branch_no || '',
                swift_code: this.data.swift_code || ''
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('dataList')).bank_account;
            processColDataToEdit(
                temp,
                this,
                {
                    black: ['created_at', 'updated_at', 'rid']
                },
                {
                    rel_type_label: 'rel_type',
                    account: 'account_rid',
                    parent: 'parent_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/bankAccountList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .bankAccountDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'bankAccountUpdate';
            } else {
                uri = 'bankAccountInsert';
            }

            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '保存成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>